(function () {
  function initCustomSelect(nativeSelect) {
    if (nativeSelect.dataset.customSelectInitialized === 'true') return;
    nativeSelect.dataset.customSelectInitialized = 'true';

    const wrapper = nativeSelect.closest('.select--custom');
    if (!wrapper) return;

    // ネイティブselectは残しつつ、見えない＆クリックできないようにする
    nativeSelect.classList.add('custom-select__native-hidden');

    // トリガーボタン
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'custom-select__trigger';

    const currentLabel = document.createElement('span');
    currentLabel.className = 'custom-select__label';
    currentLabel.textContent =
      nativeSelect.options[nativeSelect.selectedIndex].textContent.trim();

    trigger.appendChild(currentLabel);

    const arrowSvg = wrapper.querySelector(':scope > svg');
    if (arrowSvg) {
      arrowSvg.classList.add('custom-select__arrow');
      trigger.appendChild(arrowSvg);
    }

    // ドロップダウンリスト
    const list = document.createElement('ul');
    list.className = 'custom-select__list';

    Array.from(nativeSelect.options).forEach((option, index) => {
      const li = document.createElement('li');
      li.className = 'custom-select__option';
      li.dataset.value = option.value;

      // チェックアイコン
      const icon = document.createElement('span');
      icon.className = 'custom-select__check';
      icon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M13.334 4.66699L6.66732 11.3337L3.33398 8.00033" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;

      // テキスト
      const label = document.createElement('span');
      label.className = 'custom-select__option-label';
      label.textContent = option.textContent.trim();

      // li に追加
      li.appendChild(icon);
      li.appendChild(label);

      if (option.selected) {
        li.classList.add('is-selected');
      }

      li.addEventListener('click', function () {
        // すでに選択されている値なら何もしないで閉じるだけ
        if (nativeSelect.value === option.value) {
          wrapper.classList.remove('is-open');
          return;
        }

        // ネイティブselectの値を変更
        nativeSelect.value = option.value;
        currentLabel.textContent = option.textContent.trim();

        // 見た目の選択状態を更新
        list
          .querySelectorAll('.custom-select__option')
          .forEach((el) => el.classList.remove('is-selected'));
        li.classList.add('is-selected');

        var url = new URL(window.location.href);

        // すでに sort_by があれば上書き、なければ追加
        url.searchParams.set('sort_by', option.value);

        //　価格帯絞り込みの値を維持またはセット
        const hbBuckets = url.searchParams.get('hb.price.buckets');
        if (hbBuckets) {
          url.searchParams.set('hb.price.buckets', hbBuckets);
        } else {
          // ページ内hidden等で値取得できればそれをセット
          const hiddenVal = document.querySelector('input[name="hb.price.buckets"]')?.value;
          if (hiddenVal) url.searchParams.set('hb.price.buckets', hiddenVal);
        }

        // フィルタや他のクエリパラメータはそのまま維持
        window.location.href = url.toString();
        wrapper.classList.remove('is-open');
      });

      list.appendChild(li);
    });

    // トリガーの開閉
    trigger.addEventListener('click', function () {
      wrapper.classList.toggle('is-open');
    });

    // 外側クリックで閉じる
    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) {
        wrapper.classList.remove('is-open');
      }
    });

    // DOM に追加
    wrapper.appendChild(trigger);
    wrapper.appendChild(list);
  }

  function initAllCustomSelects(scope) {
    const selects = (scope || document).querySelectorAll(
      '.js-custom-select-native'
    );
    selects.forEach(initCustomSelect);
  }

  // 初期ロード
  document.addEventListener('DOMContentLoaded', function () {
    initAllCustomSelects(document);
  });

  // Shopifyのsection再読み込み対応
  document.addEventListener('shopify:section:load', function (event) {
    initAllCustomSelects(event.target);
  });

  // 絞り込み選択時のDOM変更を監視して初期化
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        // 追加されたノード内のカスタムセレクトを初期化
        initAllCustomSelects(node);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
